import { render } from "./BankDetails.vue?vue&type=template&id=00ba113c&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"

import "./BankDetails.vue?vue&type=style&index=0&id=00ba113c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ba113c"]])

export default __exports__